import CollageDesignerView from './CollageDesignerView';

export default CollageDesignerView;
